module.exports = __webpack_public_path__ + "static/media/29ADMSPC2.e81be104.jpg";